import { getImageInfo, getGenerateInfo } from '@shakkerai/services';

/**
 * 分享到社区
 */
export const shareToCommunity = async (sharedImagesInfo) => {
  const images = await Promise.all(sharedImagesInfo.map((item) => convertImageInfo(item)));
  shareImages(images);
};

/**
 * 转换单张图片数据
 * @param {*} sharedImageInfo
 */
const convertImageInfo = async (sharedImageInfo) => {
  const { outputId: id, imageId: storagePath } = sharedImageInfo;

  return Promise.all([
    getImageInfo({
      outputId: id,
    }),
    getGenerateInfo({ url: storagePath }),
  ])
    .then(([res, pngInfoRes]) => {
      const { data } = res;
      const { data: pngInfo } = pngInfoRes;

      if (data) {
        const { seed, samplingMethodName } = data.param;

        const models =
          data?.param?.mixModels?.map(({ modelId, modelVersionId: versionId }) => ({
            modelId,
            versionId,
          })) || [];

        const mixModels =
          data?.param?.mixModels?.map(
            ({ modelId, modelName, modelVersionId: versionId, modelVersionName: versionName }) => ({
              modelId,
              versionId,
              modelName,
              versionName,
            }),
          ) || [];

        return {
          type: 'generate',
          width: data?.width,
          height: data?.height,
          outputId: id,
          imageUrl: storagePath,
          generateInfo: {
            ...data?.param,
            seed,
            samplingMethod: samplingMethodName,
            metainformation: pngInfo || '',
            models,
          },
          mixModels,
        };
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

/**
 * 发送消息到社区
 * @param {*} images
 */
const shareImages = (images) => {
  window.parent?.postMessage(
    JSON.stringify({
      type: 'share',
      images,
    }),
    '*',
  );
};

export function parseMetaInformation(str = '') {
  const meta = {};
  let genStr = '';
  let otherParams = {};
  const otherKeyMap = {
    'Postprocess upscale1 to': 'Hires resize',
    Upscaler1: 'Hires upscaler',
  };
  if (typeof str !== 'string') return meta;
  try {
    if (str?.indexOf('<div>\n') === 0) {
      const div = window.document.createElement('div');
      div.innerHTML = str;
      genStr = div.children[0]?.innerText || '';
      div.children.forEach((i) => {
        const [key, value] = i.innerText.replace(/(^\n*|\n*$)/g, '').split(/\n/);
        if (key && key !== 'parameters' && value) {
          otherParams[otherKeyMap[key] || key] = value;
        }
      });
    } else {
      genStr = str;
    }

    const matched = genStr.match(/^(\n?parameters\n)?([\s\S]*?)\n*Negative prompt: *([\s\S]*?)\n(Steps:[\s\S]*)$/);
    let [, , prompt, nPrompt, params = ''] = matched || [];
    if (!matched && str) {
      const REG = /(?<prompt>[^\n]+)(?<s1>[\n\r]*)(?<params>[\s\S]*)/;
      const { groups } = REG.exec(str);
      prompt = groups.prompt;
      params = groups.params;
    }
    Object.assign(meta, { prompt, nPrompt }, otherParams);
    const pairs = params
      .replaceAll(/\n/g, '')
      .split(/[，,]\s*/)
      .map((i) => i.split(/[:：]\s*/));

    for (let p of pairs) {
      const [key, value] = p;
      if (key && value) {
        meta[key] = value;
      }
    }
  } catch (e) {
    console.warn('转化meta info失败：', e);
  }
  return meta;
}
